import { render } from "./PDFDetalhesTitulo.vue?vue&type=template&id=6beb81ba&scoped=true"
import script from "./PDFDetalhesTitulo.vue?vue&type=script&lang=js"
export * from "./PDFDetalhesTitulo.vue?vue&type=script&lang=js"

import "./PDFDetalhesTitulo.vue?vue&type=style&index=0&id=6beb81ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6beb81ba"]])

export default __exports__